import './home.css';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../context/UserContext';

export default function APNClips() {
  const { user } = useContext(UserContext);
  const isAdminOrMod = Array.isArray(user?.roles) && (user.roles.includes('admin') || user.roles.includes('moderator'));

  const card = {
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: 12,
    padding: 16,
  };

  return (
    <div className="home-page">
      <section className={user ? 'hero-offset-if-sidebar' : ''} style={{ width: '100vw', margin: 0, padding: 0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin: '0 0 8px' }}>AP‑N Clips</h2>
        <p className="hero-desc" style={{ margin: '0 auto 24px', textAlign: 'center', maxWidth: 920 }}>
          Clips & Highlights unserer Creator – als kuratierter Feed innerhalb des Webportals.
          Die Inhalte und Funktionen bauen wir im nächsten Schritt aus.
        </p>
      </section>

      <section style={{ width: '100%', maxWidth: 1100, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 12 }}>
          <Link className="highlight-card" to="/apn-clips/submit" style={{ ...card, display: 'block', textDecoration: 'none' }}>
            <div className="highlight-title" style={{ margin: '8px 8px 8px' }}>Clip einreichen</div>
            <div style={{ opacity: 0.85, lineHeight: 1.55, fontSize: 14, padding: '0 8px 8px' }}>
              Sende einen Clip/Highlight ein, damit er in den Pool kommt.
            </div>
          </Link>

          <Link className="highlight-card" to="/apn-clips/voting" style={{ ...card, display: 'block', textDecoration: 'none' }}>
            <div className="highlight-title" style={{ margin: '8px 8px 8px' }}>Community Voting</div>
            <div style={{ opacity: 0.85, lineHeight: 1.55, fontSize: 14, padding: '0 8px 8px' }}>
              Vote für die besten Clips aus der Community.
            </div>
          </Link>

          <Link className="highlight-card" to="/apn-clips/top" style={{ ...card, display: 'block', textDecoration: 'none' }}>
            <div className="highlight-title" style={{ margin: '8px 8px 8px' }}>Top Clips des Monats</div>
            <div style={{ opacity: 0.85, lineHeight: 1.55, fontSize: 14, padding: '0 8px 8px' }}>
              Hier erscheinen die Top‑Clips pro Monat.
            </div>
          </Link>

          <Link className="highlight-card" to="/apn-clips/archive" style={{ ...card, display: 'block', textDecoration: 'none' }}>
            <div className="highlight-title" style={{ margin: '8px 8px 8px' }}>Archiv</div>
            <div style={{ opacity: 0.85, lineHeight: 1.55, fontSize: 14, padding: '0 8px 8px' }}>
              Finde ältere Clips & Highlights.
            </div>
          </Link>
        </div>

        {isAdminOrMod && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 14 }}>
            <Link className="hero-btn-primary" to="/apn-clips/moderation" style={{ textDecoration: 'none' }}>
              Moderation öffnen
            </Link>
          </div>
        )}
      </section>
    </div>
  );
}
